// 2026-10-16 (Manak): Agentation page notes open from a button inside the Kiaan widget, not as their own
// floating toolbar. This is the on/off switch both sides share. No 'agentation' import and no API calls here,
// so the Kiaan widget can use it without pulling the toolbar chunk.
import { useSyncExternalStore } from 'react';

let on = false;
const listeners = new Set<() => void>();

export function setPageNotesMode(next: boolean): void {
  if (on === next) return;
  on = next;
  for (const l of listeners) l();
}

export function getPageNotesMode(): boolean {
  return on;
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function usePageNotesMode(): boolean {
  return useSyncExternalStore(subscribe, getPageNotesMode, getPageNotesMode);
}
